<script setup lang="ts">
</script>
<template>
    <a href="https://www.linkedin.com/company/propertybutton/" target="_blank">
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"
            width="100%" height="100%">
            <g>
                <path fill="#0077B5" class="st0"
                    d="M512.5,512H406.2V345.7c0-39.7-0.7-90.7-55.2-90.7c-55.3,0-63.7,43.2-63.7,87.8V512H181V170h101.9v46.8h1.5
            c14.2-26.9,48.8-55.3,100.6-55.3c107.6,0,127.5,70.8,127.5,162.9V512z M61.2,123.3C27,123.3-0.5,95.7-0.5,61.6
            C-0.5,27.6,27,0,61.2,0c34,0,61.6,27.6,61.6,61.6C122.8,95.7,95.2,123.3,61.2,123.3z M114.4,512H8V170h106.4V512z" />
            </g>
        </svg>
    </a>
</template>